import React from "react";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="29053" id="footer-essentials" className="bg-secondary text-foreground py-20 border-t border-border/40">
      <div className="container mx-auto px-6 md:px-12">
        <Separator className="bg-border/60 mb-10" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <p className="text-xs text-muted-foreground font-sans">
            &copy; {currentYear} All rights reserved.
          </p>
          
          <Badge variant="outline" className="border-primary/20 text-primary hover:bg-primary/5 hover:text-primary font-sans font-medium tracking-wide px-4 py-1.5 rounded-full transition-colors duration-300">Socal, California</Badge>
        </div>
        <p className="text-sm text-muted-foreground/80 font-sans mt-12 text-center md:text-left max-w-4xl leading-relaxed">
          Experience serene Southern California living in our quiet, professional residence. We offer four thoughtfully appointed private rooms, each featuring premium king or queen beds, climate control, and a peaceful atmosphere. Ideally located just minutes from Disneyland, Knott's Berry Farm, and Little Saigon.
        </p>
      </div>
    </section>;
}